import useSWR from "swr";
import fetcher from "../lib/fetcher";

export default function useDelivery(variety) {
  const { data, error } = useSWR(
    `/api/contracts/overdelivery/${variety}`,
    fetcher
  );

  if (error) return "An error has occurred.";
  if (!data) return 0;
  return data;
}
